import { useAuthStateValue } from '@/auth/authentication';
import { initDatadog } from '@/datadog';
import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';

export const useDatadog = () => {
    const authState = useAuthStateValue();

    useEffect(() => {
        if (!datadogRum.getInitConfiguration()) {
            initDatadog();
        }
    }, []);

    useEffect(() => {
        if (authState) {
            if (!datadogRum.getInitConfiguration()) {
                initDatadog();
            }
            datadogRum.setUser({
                id: authState.email,
                email: authState.email,
                org: authState.organization.name,
                orgId: authState.organization.uuid,
            });
        }
    }, [authState]);
};
